<template>

  <div class="atividades-materiaistestes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->

              <b-col cols="3">
                <label for="select-empresa">Empresa</label>
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-garagem_sol">Filial</label>
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false"                   
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                   <label for="select-status">Status</label> 
                <multiselect id="selecao-status-sol" v-model="value_status"  required  
                :options="statuss" 
                :multiple="true"         
                :taggable="true"                  
                @tag="addTag"     
                 @close="loadMaterialTeste()"  
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="true">                 
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="2"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid  </label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Carro ou material"></b-form-input>              
              </b-col>   

              <!-- condicional para exibir o botão planilha-->
              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2" block v-b-modal.modal-SinistroLancamentos @click="loadEmpresaCad(),loadNovoNroSinistro()"> 
                   Novo Sinistro
                </b-button>                      
              </b-col>

              <b-col cols="1">
                <br>                 
                <b-button  variant="warning" class="mr-2 mt-2"  block @click="gerarPDFLesser()"> 
                   Gerar PDF
                </b-button>                      
              </b-col>

          </b-row>
    </b-form>




        <b-card-group class="ml-3 mt-3" deck>       

            


      
      
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="TOTAL DE TESTES"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.length}}
              </h2>
              
            </b-card-text>
          </b-card>
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="success"
            header="R$ VALOR"
            header-bg-variant="success"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.map(v => v.valor).reduce((acumulador, valorAtual) => {return acumulador + parseFloat(valorAtual*100);}, 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) }}
              </h2>
              
            </b-card-text>
          </b-card>
      

      

        </b-card-group> 
      




    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="saclancamentos"  small hover striped sticky-header="756px"  :items="itemsFiltered" :fields="fields" >    
            <template #cell(valor)="data">
              {{ formatCurrency2((data.item.valor * 100)) }}
            </template>

        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregarSinistro(data.item), loadEmpresaCad(), loadFiliaisCad(),loadStatus(),  loadVeiculo(),loadFornecedor(),loadMaterial(),loadMaterialTesteAcompanhamento(),loadMaterialTesteFotosPdf() "    title="Editar teste"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-SinistroLancamentos>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

    <!--  inicio modal gravação do sinistro  -->
    <!--  inicio modal gravação do sinistro  -->
    <!--  inicio modal gravação do sinistro  -->
          <!--  MODAL SOLICITÇÕES  -->
      <div>        
        <b-modal id="modal-SinistroLancamentos" centered hide-footer size="xl"  @close="reset()" :title="`Teste de material Nº.: ${sinistro.teste_id == null ? nroSinistro :sinistro.teste_id }`"  no-close-on-esc no-close-on-backdrop>               
          <div>
                <b-row>
                  <b-col sm="4" class="mt-1">
                    <label for="input-parecer">Empresa</label>
                    <div>                    
                      <b-form-select   id="infoTipo"               
                        v-model="sinistro.empresa_id"  
                        :options="empresas"
                        class="mb-3"
                        text-field="nomeempresarial"  
                        @change="loadFiliaisCad()"                          
                      >                
                      </b-form-select>
                    </div>
                  </b-col>

                  <b-col sm="4" class="mt-1">
                    <label for="input-parecer">Filial</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.filial_id"  
                        :options="filiais"
                        class="mb-3"
                        text-field="filial" 
                        @change="loadLinhas()"                           
                      >                
                      </b-form-select>
                    </div>
                  </b-col>

                  

         

                <b-col cols="2">
                  <label for="input-live">Data cadastro</label>                 
                  <b-input-group-text >{{ sinistro.dt_cadastro !=  null ?  moment(sinistro.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
                </b-col> 

                <b-col cols="2">
                  <label for="input-live">Data alteração</label>                 
                  <b-input-group-text >{{ sinistro.dt_alteracao !=  null ?  moment(sinistro.dt_alteracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
                </b-col> 

                </b-row> 

                <b-row>
                  <b-col cols="8" class="mt-1">
                    <label for="input-live">Titulo</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.titulo" placeholder="" class="mb-3"></b-form-input>
                  </b-col> 

                  
                  <b-col cols="2"  class="mt-1">
                  <label for="input-live">Carro</label>  
                  <b-form-input v-model="sinistro.carro" @keyup.enter="loadVeiculo()" required="required" placeholder="Nro carro"></b-form-input>              
                </b-col> 
              

                <b-col cols="2" class="mt-1">            
                  <label for="input-live">Placa</label>          
                    <b-input-group-text>{{  veiculos.map(at => at.placa).join(', ') }}</b-input-group-text>  
                </b-col>                
                </b-row>

                <b-row>
                  <b-col cols="2" >
                    <label for="input-live">Solicitante</label> 
                    <b-form-input v-model="sinistro.solicitante_re" @keyup.enter="loadSolicitante()" required placeholder="RE"></b-form-input>              
                  </b-col> 

                  <b-col cols="2">
                    <label for="input-live">Nome  </label>                 
                    <b-input-group-text >{{ solicitante.funcao ? solicitante['primeiro_nome'] : '-' }}</b-input-group-text>
                  </b-col>     

                  <b-col cols="2">
                    <label for="input-live">Função  </label>                 
                    <b-input-group-text >{{ solicitante.funcao ? solicitante['funcao'] : '-' }}</b-input-group-text>
                  </b-col>     

                                    <b-col cols="2" >
                    <label for="input-live">Responsável</label> 
                    <b-form-input v-model="sinistro.responsavel_re" @keyup.enter="loadResponsavel()" required placeholder="RE"></b-form-input>              
                  </b-col> 

                  <b-col cols="2">
                    <label for="input-live">Nome  </label>                 
                    <b-input-group-text >{{ responsavel.funcao ? responsavel['primeiro_nome'] : '-' }}</b-input-group-text>
                  </b-col>     

                  <b-col cols="2">
                    <label for="input-live">Função  </label>                 
                    <b-input-group-text >{{ responsavel.funcao ? responsavel['funcao'] : '-' }}</b-input-group-text>
                  </b-col>                 
            


                </b-row>


                
                <b-row>
                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Código ERP</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.cod_material"  @keyup.enter="loadMaterial()" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             

                  <b-col cols="8" class="mt-1">
                      <label for="input-live">Material</label> 
                      <b-input-group-text >{{ materiais.descricao	 ? materiais.descricao : '-' }}</b-input-group-text>
                  </b-col> 

                  
                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ PRODUTO</label> 
                                    <NumericInput
                                      v-model="sinistro.valor"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 




                </b-row>

                <b-row>

            
                                              <b-col cols="4">
                                    <label  for="input-busca">CNPJ do fornecedor</label> 
                                    <b-form-group class="mb-3">
                                      <b-form-input v-model="sinistro.cnpj" v-mask="'##.###.###/####-##'" @keyup.enter="loadFornecedor()" required placeholder="CNPJ" v-b-tooltip.hover title="Digite o cnpj do fornecedor"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>
                               

                  <b-col cols="8" class="mt-1">
                      <label for="input-live">Fornecedor</label> 
                      <b-input-group-text >{{ fornecedores.nome ? fornecedores.nome : '-' }}</b-input-group-text>
                  </b-col> 
                </b-row>


                <b-row>
                  <b-col cols="2" class="mb-2">
                   <div>                            
                        <label  for="datepicker-placeholder">Inicio</label>                        
                        <b-form-datepicker id="datepicker-placeholder" required  v-model="sinistro.dt_instalacao" placeholder="Data instalação" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
                  </b-col>

                  <b-col cols="2" class="mb-2">
                   <div>                            
                        <label  for="datepicker-placeholder">Término</label>                  
                        <b-form-datepicker id="datepicker-placeholder" required  v-model="sinistro.dt_retirada" placeholder="Data retirada" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
                  </b-col>

                  <b-col cols="1" class="mt-1">
                    <label for="input-live">Prazo</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.prazo" placeholder="" class="mb-3"></b-form-input>
                </b-col>   

                <b-col cols="1" class="mt-1">
                    <label for="input-live">Dias</label> 
                    <b-input-group-text >{{ sinistro.dias ? sinistro.dias : '-' }}</b-input-group-text>
                </b-col>      

                
                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Km instalação</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.km_instalacao" placeholder="" class="mb-3"></b-form-input>
                </b-col>   

                                
                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Km retirado</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.km_retirada" placeholder="" class="mb-3"></b-form-input>
                </b-col>   

                <b-col cols="2" class="mt-1">
                    <label for="input-live">Km rodado</label> 
                    <b-input-group-text >{{ sinistro.km_rodado ? sinistro.km_rodado : '-' }}</b-input-group-text>
                </b-col>      

                </b-row>

                <b-row >
                  <label class="ml-3" for="input-parecer">Objetivo do teste</label> 
                  <b-col cols="12">
                    <b-form-textarea                   
                      id="infoConteudo"
                      v-model="sinistro.objetivo"
                      size="sm"
                      rows="2"            
                      placeholder="Objetivo do teste"                      
                    ></b-form-textarea>
                  </b-col>
                </b-row>





             
                <b-row>
       
                  <b-col sm="4" class="mt-1" >
                    <label for="input-parecer">Status</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.status_id"  
                        :options="statuss"
                        class="mb-3"
                        text-field="status"                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col> 



                  

                <b-col v-if="sinistro.status_id ==2" cols="4"  class="mt-1">
                  <label for="input-live">Data Aprovação</label>                 
                  <b-input-group-text >{{ sinistro.dt_aprovacao !=  null ?  moment(sinistro.dt_aprovacao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
                </b-col> 
                </b-row>

                <b-row v-if="sinistro.status_id ==2">
                  <b-col cols="12">
                     <label for="input-parecer">Motivo da aprovação</label> 
                    <b-form-textarea                   
                      id="infoConteudo"
                      v-model="sinistro.motivoaprovacao"
                      size="sm"
                      rows="2"            
                      placeholder="Motivo da aprovação"                      
                    ></b-form-textarea>
                  </b-col>
                </b-row>

                <b-col cols="12">
                  <hr id='divisao'> <!-- Linha horizontal -->
                </b-col>

                <!-- Fotos dos acompanhamentos -->
                <div>
                  <!-- O grupo de cartões para mostrar as fotos -->
                  <b-card-group deck>
                    <!-- Itera sobre o array fotosacompanhamento para gerar um cartão para cada foto -->
                    <b-card
                      v-for="(foto, index) in fotosacompanhamento"
                      :key="index"                      
                      img-alt="Imagem da foto"
                      img-top
                      class="photo-card"
                    >
                      <img :src="foto.foto_thumbnail" class="photo-thumbnail" />
                      <!--
                      <template #footer>
                        <small class="text-muted">{{ `Foto ${index + 1}` + ' - ' + acompanhamento.observacao ? acompanhamento.observacao : ''}}</small>
                      </template>
                      -->
                    </b-card>
                  </b-card-group>
                </div>
                
                <b-row>

                <b-col v-if="acompanhamento.id > 0" cols="2" class="mt-1"  >
                    <label for="input-live">Km informado</label> 
                    <b-form-input  id="teste" v-model="acompanhamento.km_informado" placeholder="" class="mb-3"></b-form-input>
                </b-col>   

                <b-col v-if="acompanhamento.id > 0" cols="10" class="mt-1">
                    <label for="input-live">Observações</label> 
                    <b-form-input  id="teste" v-model="acompanhamento.observacao" placeholder="" class="mb-3"></b-form-input>
                </b-col>   

                </b-row>







              <!-- </form> -->

              <b-row>

              <b-col cols="10">
                <b-button class="mt-2 mr-2 mb-4 " variant="success"   block @click="postSinistro(), postTesteAcompanhamento(), loadMaterialTeste()">Gravar</b-button>   
              </b-col>
              <b-col cols="2">                               
                <b-button  variant="warning" class="mr-2 mt-2 mb-4"  block @click="gerarLaudoPDF()"> 
                   Gerar laudo PDF
                </b-button>                      
              </b-col>

              </b-row>

              <b-table id="testeacompanhamento"  small hover striped sticky-header="157px"  :items="acompanhamentos" :fields="fieldsAcompanhamento" >    
                  <template slot="cell(actions)" slot-scope="data"  >
                    <b-button  @click="loadAcopanhamento(data.item), loadMaterialTesteAcompanhamentoFotos() "    title="Editar acompanhamento"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-SinistroLancamentos>                
                      <i class="fa fa-exclamation-circle"></i>              
                    </b-button> 
                  </template> 



              </b-table>


          </div>          
        </b-modal>
      </div>
    <!--  fim -  modal gravação do sinistro  -->
    <!--  fim -  modal gravação do sinistro  -->
    <!--  fim -  modal gravação do sinistro  -->

    
    <!--  inicio modal fotos do sinistro  -->
    <!--  inicio modal fotos do sinistro  -->
    <!--  inicio modal fotos do sinistro  -->
          <!--  MODAL fotos  -->

         <div>
  <b-modal id="modal-SinistroFotos" hide-footer size="lg" :title="`Cadastro de sinistro Nº.: ${sinistro.id == null ? '' :sinistro.id }`" no-close-on-backdrop>
    <div class="d-flex justify-content-center " style="height: 80vh;">
      <b-carousel
        id="carouselFoto"
        class="carouselFoto"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          v-for="(photo, index) in sinistro.fotos"
          :key="index"
          :img-src="photo"
        ></b-carousel-slide>
      </b-carousel>
    </div>
  </b-modal>
</div>



    <!--  fim -  modal fotos do sinistro  -->
    <!--  fim -  modal fotos do sinistro  -->
    <!--  fim -  modal fotos do sinistro  -->



    

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import * as XLSX from 'xlsx'
import NumericInput from '../utilitarios/NumericInput';
import jsPDF from 'jspdf';


export default {    
    name: 'sinistro',    

    
    computed : { ... mapState (['user'],),

    


/*
    computed: {
      formattedValorTotal: {
        get() {
          const formattedValue = this.sinistro.valor_total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
          console.log('Valor formatado:', formattedValue);
          return formattedValue;
        },
        // ...
      },
    },
*/



    
        itemsFiltered(){
        let valores = [];       
        valores = this.materiaistestes.filter((item) =>{ 
          const prefixo = item.carro || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const id = item.id || '';
          const operador = item.cod_material || '';
          
           return (
             prefixo.indexOf(this.search) >-1 ||
             id.indexOf(this.search) >-1 ||
             operador.indexOf(this.search) >-1            
          );
        });
           return valores

        },

        



   
    } ,

    

    data: function() {        
      
        return {
          fornecedores:[],     
          materiais:[] ,
          acompanhamentos:[],   
          acompanhamento:{}   ,
          fotosacompanhamento: [] ,   
          fotospdf:[]       ,
          solicitante:[],
          responsavel:[],
          slide: 0,
          sliding: null,

          empresas:[],   // [] lista       
          empresa:{}, 
          filiais: [],   // [] lista            
          filial:{}, 
          materiaistestes:[],
          sinistro:{},
          nroSinistro:null,  
          formattedValorTotal: '', // Variável para armazenar o valor formatado

          linhas:[],
          responsabilidades:[],
          integracoes:[],
          montas:[],
          statuss: [],   // [] lista  
          motorista:[]          ,
          
          mode: 'save',
            carregando: false,
            atualizando: false,   
            value_empresa:[],// [this.empresas],            
            value_filial:[],            
            value_status:[],     
            //value_filial:[],// [] lista     
            
            status:{},

            permissoes:[],
            permissao:{},
                                     
            sinistro:{},// [] lista              
            materiaistestes:[],// [] lista
            pedidoferias:[],    // implantado 08/07/2023
            sacT:{},// [] lista  
            materiaistestestratativa:[],// [] lista
            search:'',
       
            value_id_area:'',  
            veiculos:[],                        
            operador:[],               
            operadores:[],               
            

            fields: [
              { key: 'teste_id', label: 'Nº do teste', sortable: true },                                   
                { key: 'dt_instalacao', label: 'Inicio', sortable: true, formatter: (value, key, materiaistestes) => {
                  return moment(materiaistestes.dt_instalacao).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                
                { key: 'dt_retirada', label: 'Fim', sortable: true, formatter: (value, key, materiaistestes) => {
                    return moment(materiaistestes.dt_retirada).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                   
                { key: 'carro', label: 'Carro', sortable: true },                                                            
                { key: 'dias', label: 'Dias', sortable: true },                                                            
                { key: 'km_instalacao', label: 'Km entrada', sortable: true },                                                            
                { key: 'km_retirada', label: 'Km saida', sortable: true },                                                            
                { key: 'rodagem', label: 'Rodagem', sortable: true },                                                            
                { key: 'objetivo', label: 'Descrição', sortable: true },                                                            
                { key: 'cod_material', label: 'Codigo SB', sortable: true },                     
                { key: 'material', label: 'Descrição', sortable: true },     
                { key: 'valor', label: 'R$ valor', sortable: true },                              
                { key: 'nome', label: 'Fornecedor', sortable: true },                  
                { key: 'status', label: 'Status', sortable: true  },              
                  //{ key: 'prazo', label: 'Prazo', sortable: true }, 
                { key: 'actions', label: 'Atualizar' },                
            ],

            fieldsAcompanhamento: [
              { key: 'dt_cadastro', label: 'Data do acompanhamento', sortable: true, formatter: (value, key, acompanhamentos) => {
                  return moment(acompanhamentos.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },                                                                      
            //  { key: 'teste_id', label: 'Nº do teste', sortable: true },                                   
              { key: 'id', label: 'Nº do acompanhamento', sortable: true },                                                            
              { key: 'km_informado', label: 'Km informado', sortable: true },                                                            
              { key: 'qtd_foto', label: 'Qtd de fotos', sortable: true },                                                            
                { key: 'observacao', label: 'Descrição', sortable: true },                                                                                              
                { key: 'actions', label: 'Atualizar' },                
            ],

        }        
    },


    components: {
        Multiselect,NumericInput
    },

    
    methods: {

            loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
      },  



      loadFiliais() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiais = res.data.map(filial => {              
              return { filial_id: filial.filial_id, filial: filial.filial }        
            })
          })
      },

      loadStatus() {
          const url = `${baseApiUrl}/jb/sup/materialtestestatus`
          axios.post(url).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id, status: sta.status }
            })
          })
      },


      async loadFornecedor() { 
            let corpo = {                             
            //"empresa_id": `${this.materiais.empresa_id}`,
            "empresa_id": `${this.user.id_empresa}`,        
            "cnpj": `${this.sinistro.cnpj}`,
            "filtro": 'consultafornecedor'
            };             
          const url = `${baseApiUrl}/jb/fin/clifor`
          axios.post(url,corpo)
              .then(res => { this.fornecedores = res.data })             
      }, 

      async loadMaterial() { 
            let corpo = {                             
            "empresa_id": `${this.user.id_empresa}`,
            "material": `${this.sinistro.cod_material}`,
            "origem": 'FILTRO'
            };             
          const url = `${baseApiUrl}/jb/estoque/material/listagem`
          axios.post(url,corpo)
              .then(res => { this.materiais = res.data })             
      }, 



      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },

      

      loadEmpresaCad() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo)
          .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
          .catch(showError)
      },

      loadFiliaisCad() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo)
            .then(res => {
              this.filiais = res.data.map(fil => {                      
                return { ... fil, value: fil.id_filial_erp, filial: fil.filial }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },







        loadMaterialTeste() {
            let corpo = {    
                "empresa_id": this.value_empresa.length > 0 ? `${this.value_empresa.map(e => e.id_empresa)}`:  `${this.user.id_empresa}`,                                                              
                "filial_id": `${this.value_filial.map(f => f.filial_id)}`,                                            
                "status_id": `${this.value_status.map(s => s.id)}`,                                            
                "filtro":'web'                                        
            };
          const url = `${baseApiUrl}/jb/sup/materialteste`
          axios.post(url,corpo)
          .then(res => { this.materiaistestes = res.data })
          .catch(showError)
        },

        loadMaterialTesteAcompanhamento() {
            let corpo = {    
                "teste_id": this.value_empresa.length > 0 ? `${this.sinistro.teste_id}`:  `${this.sinistro.teste_id}`,  
                "filtro":'acompanhamento'                                        
            };
          const url = `${baseApiUrl}/jb/sup/materialteste`
          axios.post(url,corpo)
          .then(res => { this.acompanhamentos = res.data })
          .catch(showError)
        },
        
        loadMaterialTesteAcompanhamentoFotos() {
            let corpo = {    
                "acompanhamento_id": this.acompanhamento.id > 0 ? `${this.acompanhamento.id}`:  null,  
                "filtro":'foto'                                        
            };
          const url = `${baseApiUrl}/jb/sup/materialteste`
          axios.post(url,corpo)
          .then(res => { this.fotosacompanhamento = res.data })
          .catch(showError)
        },

        loadMaterialTesteFotosPdf() {
            let corpo = {    
                "teste_id": this.sinistro.teste_id > 0 ? `${this.sinistro.teste_id}`:  null,  
                "filtro":'fotopdf'                                        
            };
          const url = `${baseApiUrl}/jb/sup/materialteste`
          axios.post(url,corpo)
          .then(res => { this.fotospdf = res.data })
          .catch(showError)
        },



      formatCurrency2(amount) {
      const number = parseFloat(amount);
      if (isNaN(number)) {
        return 'R$ 0,00'; // Valor padrão se não for um número
      }
      return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },


    ////////////////////////////  gerar pdf dos testes

async gerarPDFLesser() {
  try {
    const doc = new jsPDF();
    const startX = 14;
    const startY = 10;
    const fontSize = 7; // Define o tamanho da fonte desejado

    doc.setFontSize(fontSize); // Define o tamanho da fonte para todos os textos seguintes

    // URL da imagem
    const imageUrl = 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/logotipo/LOGO_SAMBAIBA.png';

    // Função para carregar a imagem a partir da URL
    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.crossOrigin = 'Anonymous'; // Para evitar problemas de CORS
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    };

    const image = await loadImage(imageUrl);

    // Adicionar tabela com imagem, texto e campos antes do texto 'CF7'
    const tableData = [
      [
        { content: '', image: image, width: 16, height: 16 }, // Primeira coluna: Imagem
        { content: 'ACOMPANHAMENTO DE PEÇAS EM TESTE' }, // Segunda coluna: Texto
        {
          content: '\nData Emissão \n' + moment().format('DD/MM/YYYY HH:mm')+'\n' // Formatar a data corretamente
        } // Terceira coluna: Texto
      ]
    ];

        // Adiciona a primeira tabela
    doc.autoTable({
      startY: startY,
      body: tableData,
      columnStyles: {
        0: { cellWidth: 27, halign: 'center', valign: 'middle' }, // Tamanho e alinhamento da coluna 0 (Imagem)
        1: { cellWidth: 115, halign: 'center', valign: 'middle' }, // Tamanho e alinhamento da coluna 1 (Texto)
        2: { cellWidth: 40, halign: 'center', valign: 'middle' }   // Tamanho e alinhamento da coluna 2 (Texto)
      },
      styles: {
        fillColor: [255, 255, 255], // Fundo branco
        textColor: [0, 0, 0], // Texto preto
        lineColor: [0, 0, 0], // Bordas pretas
        halign: 'center', // Centralizar texto horizontalmente
        valign: 'middle' // Centralizar texto verticalmente
      },
      tableLineColor: [0, 0, 0], // Bordas pretas
      tableLineWidth: 0.1, // Largura das bordas
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.raw.image) {
          doc.addImage(data.cell.raw.image.src, 'PNG', data.cell.x + 2, data.cell.y + 2, data.cell.raw.width, data.cell.raw.height);
        }

        // Desenhar linha vertical entre a segunda e terceira colunas
        if (data.column.index === 1) {
          const cell = data.cell;
          doc.setDrawColor(0, 0, 0); // Cor preta para a linha
          doc.setLineWidth(0.1); // Largura da linha
          doc.line(cell.x + cell.width, cell.y, cell.x + cell.width, cell.y + cell.height);
        }
      }
    });


    // Preparar os dados para o PDF com formatação de moeda
    const dadosParaPDF = this.itemsFiltered.map((item, index) => {
      const valorUnitario = parseFloat(item.valor) || 0;
      
      return [      
        item.carro,  
        moment(item.dt_instalacao).format('DD/MM/YYYY').replace('Data inválida','-'),
        moment(item.dt_retirada).format('DD/MM/YYYY').replace('Data inválida','-'),
        item.dias,
        item.km_instalacao,
        item.km_retirada,
        item.km_rodado,
        item.cod_material || '', // Coluna 2: Código
        item.material || '', // Coluna 2: Código
        item.nome || '', // Coluna 2: Código
        item.filial_id || '', // Coluna 2: Código
        item.status, // Coluna 4: Status
  //      valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) // Coluna 5: Valor unitário formatado
      ];
    });

    // Cabeçalhos para a tabela de dados
    const headers = ['Carro','INICIO','FIM','DIAS','KM ENTRADA','KM SAIDA', 'KM RODADO','CÓDIGO', 'MATERIAL','FORNECEDOR','LOCAL','STATUS'];

    // Número de linhas por página
    const rowsPerPage = 18;

    for (let i = 0; i < dadosParaPDF.length; i += rowsPerPage) {
      const currentData = dadosParaPDF.slice(i, i + rowsPerPage);

      if (i > 0) {
        doc.addPage();
      }

      doc.autoTable({
        startY: 31,
        head: [headers],
        body: currentData,
        theme: 'plain',
        columnStyles: {
          0: { cellWidth: 12, halign: 'center' }, // TESTE
          1: { cellWidth: 13, halign: 'center' }, // INICIO
          2: { cellWidth: 13, halign: 'center' }, // FIM
          3: { cellWidth: 7, halign: 'center' }, // DIAS
          4: { cellWidth: 16, halign: 'right' }, // KM ENTRADA
          5: { cellWidth: 14, halign: 'right' }, // KM SAIDA
          6: { cellWidth: 16, halign: 'right' }, // KM_RODADO
          7: { cellWidth: 11, halign: 'right' }, // CODIGO
          8: { cellWidth: 31, halign: 'left' }, // MATERIAL
          9: { cellWidth: 20, halign: 'left' }, // FORNECEDOR
          10: { cellWidth: 9, halign: 'center' }, // LOCAL DA GARAGEM
          11: { cellWidth: 20, halign: 'left' }, // STATUS
    //      12: { cellWidth: 20, halign: 'right' }, // VALOR          

        },
        styles: {
          fontSize: 6,
          cellPadding: 1,
          valign: 'middle',
          lineColor: [0, 0, 0],
          lineWidth: 0.1 // Adicionar bordas pretas
        },
        headStyles: { fontStyle: 'bold' },
        didDrawCell: function (data) {
          const cell = data.cell;
          doc.rect(cell.x, cell.y, cell.width, cell.height, 'S'); // Desenhar as bordas
        }
      });
    }

    const pageCount = doc.internal.getNumberOfPages();
    const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const footerX = 10;
      const footerY = doc.internal.pageSize.height - 10;      
      const pageNumber = 'Página.: ' + i + ' de ' + pageCount;
      const footerText = pageNumber;

      doc.setFontSize(footerFontSize); // Define o tamanho da fonte
      doc.text(footerText, footerX, footerY);    
    }

    // Salvar o PDF com o nome apropriado
    doc.save('Teste_' + (this.sinistro.teste_id || 'sem_id') + '.pdf');
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
  }
},






async gerarLaudoPDF() {
  try {
    const doc = new jsPDF();
    const fontSize = 8;
    doc.setFontSize(fontSize);

    const loadImageAsBase64 = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = reject;
      });
    };

    const imageUrl = 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/logotipo/LOGO_SAMBAIBA.png';
    const imageBase64 = await loadImageAsBase64(imageUrl);

    const tableData = [
      [
        { content: '', image: imageBase64, width: 16, height: 16 },
        { content: 'RELÁTORIO DE TESTE DO CARRO Nº ' + this.sinistro.carro },
        {
          content: (this.sinistro.teste_id ? 'Nº teste \n' + this.sinistro.teste_id : 'Nº teste \n' + this.sinistro.teste_id) + '\n' +
                   'Data inicio \n' + moment(this.sinistro.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-')
        }
      ]
    ];

    doc.autoTable({
      startY: 10,
      body: tableData,
      columnStyles: {
        0: { cellWidth: 27, halign: 'center', valign: 'middle' },
        1: { cellWidth: 115, halign: 'center', valign: 'middle' },
        2: { cellWidth: 40, halign: 'center', valign: 'middle' }
      },
      styles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        halign: 'center',
        valign: 'middle'
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.1,
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.raw.image) {
          const img = data.cell.raw.image;
          const imgWidth = data.cell.raw.width;
          const imgHeight = data.cell.raw.height;
          const xOffset = (data.cell.width - imgWidth) / 2;
          const yOffset = (data.cell.height - imgHeight) / 2;
          doc.addImage(img, 'PNG', data.cell.x + xOffset, data.cell.y + yOffset, imgWidth, imgHeight);
        }
      }
    });

    let newTableStartY = doc.autoTable.previous.finalY + 1;

    const newTableData = [
      ['Titulo.: ' + this.sinistro.material + '\n' + 'Fornecedor.: ' + (this.sinistro.nome ? this.sinistro.nome : 'Aguardando controle vincular') + '\n' + 'Código interno SB.: ' + this.sinistro.cod_material + '\nReferência do fabricante.: ']
    ];

    doc.autoTable({
      startY: newTableStartY,
      body: newTableData,
      columnStyles: {
        0: { cellWidth: 180, halign: 'left' }
      },
      styles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        halign: 'left',
        valign: 'middle',
        fontSize: fontSize,
        cellPadding: 2
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.1
    });

    newTableStartY = doc.autoTable.previous.finalY + 1;

    const tabelaKM = [
      [
        'KM INSTALAÇÃO: ' + (this.sinistro.km_instalacao || '-'),
        'KM RETIRADA: ' + (this.sinistro.km_retirada || '-'),
        'RODAGEM: ' + (this.sinistro.km_rodado || '-')
      ],
      [
        'DATA INSTALAÇÃO: ' + (moment(this.sinistro.dt_instalacao).format('DD/MM/YYYY') || '-').replace('Data inválida','-'),
        'DATA RETIRADA: ' + (moment(this.sinistro.dt_retirada).format('DD/MM/YYYY') || '-').replace('Data inválida','-'),
        'DIAS EM TESTE: ' + (this.sinistro.dias || '-')
      ]
    ];

    doc.autoTable({
      startY: newTableStartY,
      body: tabelaKM,
      columnStyles: {
        0: { cellWidth: 60, halign: 'left' },
        1: { cellWidth: 60, halign: 'left' },
        2: { cellWidth: 60, halign: 'left' }
      },
      styles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        halign: 'left',
        valign: 'middle',
        fontSize: fontSize,
        cellPadding: 2
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.1
    });

    newTableStartY = doc.autoTable.previous.finalY + 1;

    const tabelaObjetivoObservacao = [
      ['OBJETIVO: ' + this.sinistro.objetivo],
      ['OBSERVAÇÃO: ' + (this.sinistro.titulo || '')]
    ];

    doc.autoTable({
      startY: newTableStartY,
      body: tabelaObjetivoObservacao,
      columnStyles: {
        0: { cellWidth: 182, halign: 'left' }
      },
      styles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        halign: 'left',
        valign: 'middle',
        fontSize: fontSize,
        cellPadding: 2
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.1
    });

    newTableStartY = doc.autoTable.previous.finalY + 1;

    const headers = ['Data aferição', 'Foto 1', 'Foto 2', 'Foto 3', 'Foto 4', 'Foto 5'];
    const dadosParaPDF = [];

    for (const item of this.fotospdf) {
      const rowData = [moment(item.dt_cadastro).format('DD/MM/YYYY')];
      for (let i = 0; i < 5; i++) {
        const url = item.fotos[i];
        if (url) {
          try {
            const imgBase64 = await loadImageAsBase64(url);
            rowData.push({ image: imgBase64, width: 28, height: 28 });
          } catch (error) {
            console.error('Erro ao carregar a imagem:', error);
            rowData.push('');
          }
        } else {
          rowData.push('');
        }
      }
      dadosParaPDF.push(rowData);
    }

doc.autoTable({
  startY: newTableStartY,
  head: [headers],
  body: dadosParaPDF,
  theme: 'plain',
  columnStyles: {
    0: { cellWidth: 22 },
    1: { cellWidth: 32 },
    2: { cellWidth: 32 },
    3: { cellWidth: 32 },
    4: { cellWidth: 32 },
    5: { cellWidth: 32 }
  },
  styles: {
    fontSize: 6,
    cellPadding: 2,
    valign: 'middle',
    halign: 'center',
    lineWidth: 0.1,
    minCellHeight: 32 // Valor padrão para altura mínima
  },
  headStyles: {
    fontStyle: 'bold',
    cellPadding: 2,
    minCellHeight: 10 // Altura mínima para cabeçalhos
  },
  didDrawCell: function (data) {
    const cell = data.cell;
    const doc = data.doc;

    // Desenho da borda da célula
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.1);
    doc.rect(cell.x, cell.y, cell.width, cell.height);

    // Condicional para desenhar imagens apenas nas linhas de dados
    if (data.row.index >= 0 && data.column.index > 0 && cell.raw && typeof cell.raw === 'object' && cell.raw.image) {
      const img = cell.raw.image;
      const imgWidth = cell.raw.width;
      const imgHeight = cell.raw.height;

      // Ajusta o tamanho da célula para ser 2% maior que a imagem
      const cellWidth = imgWidth * 1.08;
      const cellHeight = imgHeight * 1.08;

      // Ajusta a altura da célula para acomodar a imagem
      cell.height = Math.max(cell.height, cellHeight);

      // Calcula o deslocamento para centralizar a imagem na célula
      const xOffset = (cell.width - imgWidth) / 2;
      const yOffset = (cell.height - imgHeight) / 2;

      // Adiciona a imagem na célula
      doc.addImage(img, 'PNG', cell.x + xOffset, cell.y + yOffset, imgWidth, imgHeight);
    }
  }
});

const pageCount = doc.internal.getNumberOfPages();
const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const footerX = 10;
      const footerY = doc.internal.pageSize.height - 10;
      const currentDate = moment().format('DD/MM/YYYY - HH:mm');
      const pageNumber = 'Página ' + i + ' de ' + pageCount;
      const footerText = 'Data emissão: ' + currentDate + ' | ' + pageNumber;

      doc.setFontSize(footerFontSize); // Define o tamanho da fonte
      doc.text(footerText, footerX, footerY);

      // Verifica se estamos na última página
      if (i === pageCount) {
        const assinaturaY = footerY - 10; // Ajuste conforme necessário
        doc.text("____________________________________________________________________", footerX, assinaturaY - 5);
        doc.text("Aprovado: ", footerX, assinaturaY);
      }
    }




    doc.save('laudo.pdf');
  } catch (error) {
    console.error('Erro ao gerar o PDF:', error);
  }
}


,



        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.pedidoferias

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'pedido_de_ferias.xlsx');
      },


      loadCarregarSinistro(sinistro){
            this.sinistro = { ...sinistro }
      },   
      
      loadAcopanhamento(acompanhamentos){

            this.acompanhamento = { ...acompanhamentos }
      },   

      postSinistro() {                        
        let corpo = { 
          "id": this.nroSinistro ? this.nroSinistro : `${this.sinistro.teste_id}`,
          "empresa_id": `${this.sinistro.empresa_id}`,
          "filial_id": `${this.sinistro.filial_id}`,
          "carro_id": `${this.veiculos.map(at => at.id_carro).join(', ')}`,    
          "clifor_id": this.fornecedores.id !="undefined" ?`${this.fornecedores.id}` : null,                
          "material_id": `${this.materiais.id_material}`,                
          "titulo": `${this.sinistro.titulo}`,               
          "objetivo": `${this.sinistro.objetivo}`,                
          "dt_instalacao": this.sinistro.dt_instalacao ? `${this.sinistro.dt_instalacao}`: null,          
          "dt_retirada": this.sinistro.dt_retirada? `${this.sinistro.dt_retirada}`: null,          
          "prazo": this.sinistro.prazo?  `${this.sinistro.prazo}`: null,     
          "km_instalacao": this.sinistro.km_instalacao? `${this.sinistro.km_instalacao}` : null,                
          "km_retirada": this.sinistro.km_retirada ? `${this.sinistro.km_retirada}` : null,                
          "km_rodado": this.sinistro.km_rodado?  `${this.sinistro.km_rodado}`: null,                          
          "id_funcionarioErp": `${this.user.id_funcionario_erp}`,                
          "status_id": `${this.sinistro.status_id}`,         
          "motivoaprovacao": this.sinistro.motivoaprovacao !="undefined" ?`${this.sinistro.motivoaprovacao}` : null,                
          "valor": `${ parseFloat(this.sinistro.valor / 100)}`,                                                       
          
        };

        const url = `${baseApiUrl}/jb/sup/testematerial`   

            axios.post(url,corpo).then(() => {
              this.loadSinistro
              this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores                    
                })
                .catch(showError)
      },

      postTesteAcompanhamento() {                        
        let corpo = { 
          "empresa_id": `${this.sinistro.empresa_id}`,
          "filial_id": `${this.sinistro.filial_id}`,
          "id": this.acompanhamento.id ? `${this.acompanhamento.id}`: null,
          "teste_id": `${this.acompanhamento.teste_id}`,                
          "km_informado": `${this.acompanhamento.km_informado}`,                
          "observacao": `${this.acompanhamento.observacao}`,                                  
          "id_funcionarioErp": `${this.user.id_funcionario_erp}`
        };

        const url = `${baseApiUrl}/jb/sup/testematerial/acompanhamento`   

            axios.post(url,corpo).then(() => {
              this.loadSinistro
              this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores                    
                })
                .catch(showError)
      },

      async loadSolicitante() { 
            let corpo = {                             
            "registro": `${this.sinistro.solicitante_re}`,
            "id_empresa": `${this.user.id_empresa}`, 
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.solicitante = res.data })             
      },  

      async loadResponsavel() { 
            let corpo = {                             
            "registro": `${this.sinistro.responsavel_re}`,
            "id_empresa": `${this.user.id_empresa}`, 
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.responsavel = res.data })             
      },  

      reset() {                        
            this.sinistro = {}
            this.fotosacompanhamento = []
            this.loadMaterialTeste()
            this.nroSinistro =null
      },



      limparFiltro(){
        this.search= ""
      },



        loadVeiculo() {
          let corpo = {    
              "empresa_id": `${this.user.id_empresa}`,
              "carro": `${this.sinistro.carro}`                 
          };
          const url = `${baseApiUrl}/jb/manutencao/frota/listagem`
          axios.post(url,corpo)                      
          .then(res => { this.veiculos = res.data })                      
          .catch(showError)
        },
  
    },  


  mounted() {    
        this.loadMaterialTeste()
        this.loadEmpresas()
        this.loadEmpresaCad()
        this.loadStatus()

        
  },
    

}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.carouselFoto {
  max-width: 65%;
  height: auto;
  /* Defina a altura máxima que você deseja para as imagens */
  max-height: 100px;
}

.photo-thumbnail {
  width:  5.5cm; /* Largura da imagem */
  height: 6cm; /* Altura da imagem */
  object-fit: cover; /* Ajusta a imagem para cobrir a área definida */
}

/* Ajusta o estilo do cartão para se adequar ao tamanho da imagem */
.photo-card {
  display: flex;
  justify-content: center;
}

#divisao {
      border: 0;
      height: 4px;
      background: #1405ee; /* Cor da linha */
      margin: 20px 0; /* Espaço acima e abaixo da linha */
    }



</style>